import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import "@deorderbook/contracts";
import { useSniperContract as o } from "../store/sniperContract.mjs";
import "../store/subgraph.mjs";
function f(t, r) {
  return o(t).balanceOf(r);
}
function S(t, r, n) {
  return o(t).allowance(r, n);
}
function b(t, r, n) {
  return o(t, !0).approve(r, n);
}
function s(t) {
  return o(t).totalSupply();
}
export {
  S as allowance,
  b as approve,
  f as balanceOf,
  s as totalSupply
};
//# sourceMappingURL=sniper.mjs.map
